import React, {useState} from "react";
import {styled} from "@mui/material/styles";
import {Box, Button, Slider, Typography, useMediaQuery,} from "@mui/material";
import {useTranslation} from "react-i18next";

const Separator = styled("div")(
    ({theme}) => `
  height: ${theme.spacing(3)};
`
);

export default function LinearSliderQuestion({
                                                 data,
                                                 addQuestion,
                                                 deleteQuestionsAfterIndex,
                                                 goToNextQuestion,
                                                 isVisible,
                                                 addToUpdateQuestions,
                                                 deleteFromQuestionToUpdate,
                                             }) {
    const {t} = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)"); // Check for mobile view

    // State to manage the slider's current value
    const [value, setValue] = useState(data.currentValue || -1);
    const [showError, setShowError] = useState(false); // Track error state for required fields
    const language = localStorage.getItem("i18nextLng");


    // Function to handle slider value changes
    const handleSliderChange = (event, newValue) => {
        setValue(newValue);
        setShowError(false); // Clear any error messages when the slider is moved

        // Delete subsequent questions when the value changes
        if (newValue !== data?.currentValue) {
            deleteQuestionsAfterIndex(data);
            deleteFromQuestionToUpdate(data);
        }


    };

    // Function to handle the next button click
    const handleNextClick = () => {

        if (data && value > -1 && value !== data.currentValue) {
            addToUpdateQuestions(data, value);
        }

        // Add follow-up questions if the selected value has a `question_object`
        if (data?.question_object) {
            addQuestion(data.question_object);
        } else {
            goToNextQuestion();
        }

    };

    function handleSkipClick() {
        if (data?.associated_step_id === "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b") {
            if (data?.question_object) {

                addQuestion(data?.question_object);
            } else {
                // Otherwise, move to the next question
                goToNextQuestion(null, true);
            }
        } else {
            goToNextQuestion(null, true);
        }
    }

    // Helper function to format slider values
    function valuetext(value) {
        return `${value}`;
    }

    return (
        <Box style={{padding: "20px"}}>
            {/* Question */}
            <Typography variant="subtitle1" sx={{mb: 2}}>
                {language === "fr" ? data?.question_fr : data.question}
            </Typography>

            {/* Slider */}
            <Box>
                <Slider
                    aria-labelledby="track-false-slider"
                    getAriaValueText={valuetext}
                    value={value}
                    marks={data.marks}
                    step={data.step}
                    valueLabelDisplay={data.valueLabelDisplay || "auto"}
                    onChange={handleSliderChange}
                    max={data.max}
                    min={data.min}
                    // disabled={data.disabled} // Disable slider if specified
                />
                <Separator/>
            </Box>

            {/* Error Message */}
            {showError && (
                <Typography color="error" variant="body2" sx={{mt: 2}}>
                    {t("This field is required.")}
                </Typography>
            )}


            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                {isVisible(data) && (
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{
                            height: "50px",
                            width: data?.associated_step_id !== "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b" ? "50%" : "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        onClick={handleNextClick}
                        disabled={value === -1} // Disable if required fields are empty
                    >
                        {data?.last_step_question_2 ? t("finish") : t("next")}
                    </Button>
                )}
                {isVisible(data) && (
                    <Button
                        style={{
                            height: "50px",
                            width: "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        color="secondary"
                        variant="contained"
                        onClick={handleSkipClick}
                    >
                        {t("skip")}
                    </Button>
                )}
            </div>

        </Box>
    );
}
